import React, { useRef } from 'react'
import './labelPDF.scss'
import AutoAdjustText from '../Common/AutoAdjustText/AutoAdjustText';
import { formatDateForLabelPDF, formatDilution } from '../../utils/format.utils';
import api from '../../middleware/api';
import downloadPDF from '../../utils/pdf.utils';

const TooltipLabelPreview = ({ capsule, setEditMode }) => {

    const customerRef = useRef(null);
    const capsuleNameRef = useRef(null);

    const handleEditMode = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setEditMode(true)
    }



    const hanldeDownloadPDF = async () => {
        if (customerRef.current === null || capsuleNameRef.current === null) return;


        let customerFontSize = window.getComputedStyle(customerRef.current.firstChild).getPropertyValue('font-size')
        let capsuleNameFontSize = window.getComputedStyle(capsuleNameRef.current.firstChild).getPropertyValue('font-size')

        // Take the font size of the customer and the capsule name
        // Convert it to number
        // Divide it by 2 and return it as a string

        const customerFontSizeNumber = parseInt(customerFontSize.replace('px', ''));
        const capsuleNameFontSizeNumber = parseInt(capsuleNameFontSize.replace('px', ''));

        customerFontSize = ((customerFontSizeNumber / 2)).toString() + 'px';



        capsuleNameFontSize = (capsuleNameFontSizeNumber / 2).toString() + 'px';



        const payload = {
            customer_name: capsule.customer,
            capsule_name: capsule.capsule_name,
            dilutions: formatDilution(capsule.dilutions),
            customerNameSize: customerFontSize,
            capsuleNameSize: capsuleNameFontSize
        }
        console.log(payload)

        const response = await api.post(`/pdf`, payload);
        // Check if the response is successful
        if (response.status === 200) {
            downloadPDF(response.data, `${capsule.customer} - ${capsule.capsule_name}`);
        }
    };

    return (
        <div className='flex flex-col gap-y-4 animate-fadeIn'>

            <div className='pdf-container'>
                <div className='pdf-infos'>
                    <div ref={customerRef} className='pdf-details '>
                        <AutoAdjustText editable={false} text={capsule.customer} minFontSize={8} maxFontSize={14} />
                    </div>
                    <div ref={capsuleNameRef} className='pdf-details justify-center'>
                        <AutoAdjustText editable={false} text={capsule.capsule_name} minFontSize={8} maxFontSize={12} />
                    </div>
                    <div className='pdf-details pdf-footer'>
                        <p>{formatDateForLabelPDF(capsule.creation_date)}</p>
                        <p>{formatDilution(capsule.dilutions)}</p>
                    </div>
                </div>

            </div>
            <div className='flex flex-row justify-center w-4/5 self-center h-7'>
                <button className='btn btn-primary h-7 min-h-2 text-white' onClick={handleEditMode}  color='warning'>Modifier</button>
                <button className='btn btn-primary h-7 min-h-2 text-white' onClick={hanldeDownloadPDF} color='primary'>Télécharger</button>
            </div>
        </div>
    )
}

export default TooltipLabelPreview
